import getPageCustomizableHeaderProps from 'hb-react/shared/apps/PageCustomizables/utils/getPageCustomizableHeaderProps';

import getNewsHeaderControls from '../getNewsHeaderControls';

const getNewsHeaderProps = ({ appPageConfig }) => {
  if (!appPageConfig) {
    return null;
  }

  const { controls } = getNewsHeaderControls();

  const headerProps = getPageCustomizableHeaderProps({
    appPageConfig,
    controls,
  });

  return headerProps;
};

export default getNewsHeaderProps;
